export const addScriptsOnBody = ( src ) => {
	const script = document.createElement( 'script' );
	script.src = src;
	document.body.appendChild( script );
};

export const getElementById = ( id ) => {
	return document.getElementById( id );
};
